import type { i18n as I18nInstance } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { HashRouter } from 'react-router';
import { ForeignDataDialog } from '../features/sync/ForeignDataDialog';
import { WelcomeGate } from '../features/welcome/WelcomeGate';
import { AppRoutes } from './router';
import { ServicesProvider } from './ServicesContext';
import type { Services } from './services';

export function App({ services, i18n }: { services: Services; i18n: I18nInstance }) {
  return (
    <ServicesProvider services={services}>
      <I18nextProvider i18n={i18n}>
        <HashRouter>
          <WelcomeGate>
            <AppRoutes />
          </WelcomeGate>
          <ForeignDataDialog />
        </HashRouter>
      </I18nextProvider>
    </ServicesProvider>
  );
}
